import { DeliveryMethod } from "domain/deliveryMethod";
import { ContractType } from "domain/contract";
import { useState } from "react";
import * as _ from "lodash";
import deliveryMethodService from "features/offers/deliveryMethodService";
import useDeliveryMethods from "features/deliveryMethods/useDeliveryMethods";

const getCached = _.memoize(async (contractType: ContractType) => {
    return await deliveryMethodService.list(contractType);
});

export default function useAllowedDeliveryMethods(contractType: ContractType): DeliveryMethod[] {
    const deliveryMethods = useDeliveryMethods();
    const [allowed, setAllowed] = useState<DeliveryMethod[]>(null);

    if (allowed == null) {
        getCached(contractType).then(setAllowed);
    }

    return allowed ?? deliveryMethods.map(m => m.deliveryMethod);
}